import { render, staticRenderFns } from "./TextBodyMedium.vue?vue&type=template&id=1fbb7ebc&scoped=true"
import script from "./TextBodyMedium.vue?vue&type=script&lang=js"
export * from "./TextBodyMedium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb7ebc",
  null
  
)

export default component.exports